export default {
  HYBRID_PRICE: 1700,
  HYBRID_INSTALLATION_PRICE: 3400,
  MAX_HYBRID_PRICE: 2500,
  MAX_HYBRID_INSTALLATION_PRICE: 4000,
  ELECTRIC_PRICE: 509,
  ELECTRIC_INSTALLATION_PRICE: 3000,
  ELECTRIC_ANNUAL_KILOWATTS: 3493,
  HYBRID_ANNUAL_KILOWATTS: 836,
  HYBRID_MODEL_FOR_API_REQUEST: '10E50-HP5U30',
  ZIP_CODE_LENGTH: 5,
  API_FOR_REBATE_PROGRAMS: 'https://rheem.ecorebates.com/api/search/rheem/productRebateDetails.json?sku=10E50-HP5U30',
  API_FOR_STATE_BY_ZIP: 'https://api.zippopotam.us/us',
  MAIN_COLOR: '#3279B6',
  IMG_DIR: '/wp-content/themes/RheemTheme/hybrid-saving-calculator/dist-richmond/img',
  AVERAGE_RATE: 0.14,
  RATES: [
    { state: 'Hawaii', rate: 0.3962 },
    { state: 'New Hampshire', rate: 0.2439 },
    { state: 'Massachusetts', rate: 0.3028 },
    { state: 'California', rate: 0.3268 },
    { state: 'Connecticut', rate: 0.2915 },
    { state: 'Rhode Island', rate: 0.2871 },
    { state: 'Alaska', rate: 0.247 },
    { state: 'New York', rate: 0.2469 },
    { state: 'Maine', rate: 0.263 },
    { state: 'Vermont', rate: 0.2535 },
    { state: 'Michigan', rate: 0.1871 },
    { state: 'Pennsylvania', rate: 0.1807 },
    { state: 'Illinois', rate: 0.1721 },
    { state: 'Indiana', rate: 0.1633 },
    { state: 'New Jersey', rate: 0.1964 },
    { state: 'Wisconsin', rate: 0.169 },
    { state: 'Delaware', rate: 0.181 },
    { state: 'Maryland', rate: 0.1842 },
    { state: 'District of Columbia', rate: 0.1893 },
    { state: 'Ohio', rate: 0.1656 },
    { state: 'Nevada', rate: 0.1527 },
    { state: 'Alabama', rate: 0.1548 },
    { state: 'Kansas', rate: 0.1483 },
    { state: 'Colorado', rate: 0.1526 },
    { state: 'Minnesota', rate: 0.1486 },
    { state: 'Texas', rate: 0.156 },
    { state: 'New Mexico', rate: 0.1447 },
    { state: 'South Carolina', rate: 0.1594 },
    { state: 'Virginia', rate: 0.1494 },
    { state: 'Oklahoma', rate: 0.1311 },
    { state: 'West Virginia', rate: 0.1587 },
    { state: 'Georgia', rate: 0.1431 },
    { state: 'Florida', rate: 0.1427 },
    { state: 'Louisiana', rate: 0.1187 },
    { state: 'Kentucky', rate: 0.1377 },
    { state: 'North Carolina', rate: 0.1511 },
    { state: 'Mississippi', rate: 0.1426 },
    { state: 'Iowa', rate: 0.1328 },
    { state: 'South Dakota', rate: 0.1346 },
    { state: 'Arizona', rate: 0.1517 },
    { state: 'Tennessee', rate: 0.1377 },
    { state: 'Arkansas', rate: 0.246 },
    { state: 'Montana', rate: 0.1254 },
    { state: 'Missouri', rate: 0.127 },
    { state: 'Nebraska', rate: 0.1225 },
    { state: 'Wyoming', rate: 0.1278 },
    { state: 'Oregon', rate: 0.1484 },
    { state: 'North Dakota', rate: 0.1131 },
    { state: 'Idaho', rate: 0.1134 },
    { state: 'Utah', rate: 0.1091 },
    { state: 'Washington', rate: 0.1239 },
  ],
  GET_REBATE_PROGRAMS: () => [],
  STEPS: [
    { id: 1, label: '1. Price & Rate' },
    { id: 3, label: '2. Return on investment' },
  ],
  ROI_BACKGROUND_IMAGE: 'ROI-background-richmond.jpg',
  SHOW_KWIKCOMFORT_BLOCK: false,
  FULL_LEGAL_DISCLAIMER: false,
};
